import { ClassData } from '@models/class-data';
import { Address } from '@models/shared/address.model';

export class EventSectionMap {
  id: number;

  eventSectionId?: number;

  addresses: Address[];

  order: number;

  constructor(json: ClassData<EventSectionMap>) {
    this.id = +json.id;

    this.eventSectionId = json.eventSectionId;

    this.addresses = json.addresses
      ? json.addresses.map((address) => new Address(address))
      : [];

    this.order = json.order;
  }

  getFilledAddresses(): Address[] {
    if (!this.addresses) {
      return [];
    }

    return this.addresses.filter(
      (address) =>
        address.isFilled() ||
        (address.isPartiallyFilled() && address.hasLatLng()),
    );
  }
}
